//
//	jQuery core library
//

import $ from 'jquery';

//
//	make jquery global
//
(window as unknown as {$: unknown}).$ = $;
(window as unknown as {jQuery: unknown}).jQuery = $;

//
//	jQuery.htmlPrefilter changes
//
//	If you don't use jQuery Migrate, don't add it just for this one workaround. Instead, you can revert to the previous behavior by redefining jQuery.htmlPrefilter after loading jQuery.
//	Note that if you do this, you lose the jQuery 3.5.0 security fix, and you have to be more careful with what HTML you pass to jQuery manipulation methods; regular HTML sanitizing will not be enough. Some security libraries have special sanitization settings for jQuery.
//
// eslint-disable-next-line regexp/no-super-linear-backtracking, regexp/optimal-quantifier-concatenation, unicorn/better-regex, unicorn/no-hex-escape
const rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi;
// eslint-disable-next-line no-restricted-globals
jQuery.htmlPrefilter = function (html) {
	return html.replaceAll(rxhtmlTag, '<$1></$2>');
};
